
import {Col} from "react-bootstrap";

function MainPage() {
    return (
        <Col lg={12} className="px-0">
            <p >
                MOLOR: Morphologically Linked Old Irish Resource was a project hosted at the Centro Interdisciplinare di Ricerche
                per la Computerizzazione dei Segni dell’Espressione (CIRCSE), Università Cattolica del Sacro Cuore, Milan, Italy.
                The aim of the project, which ran from 2023–2025, was (and is) to make distributed lexical resources for Old Irish (600–900 CE) interact by using state-of-the-art data models and lexicographic standards based on the Linguistic Linked Open Data (LLOD) principles.
                For more information about the project, see  <a target="_blank" rel="noreferrer" href="https://centridiricerca.unicatt.it/circse/en/projects/moLor.html">https://centridiricerca.unicatt.it/circse/en/projects/moLor.html</a>.
            </p>
            <p >
                A major output of the project was an Old Irish Lemma Bank, similar in design to the one created for Latin as part of the <a target="_blank" rel="noreferrer" href="https://lila-erc.eu">LiLa project</a>. The MOLOR Lemma Bank currently consists of approximately 6000 Old Irish lemmas, covering nouns, numerals and verbs. Data is available as a graph database (RDF triples - Turtle format). The MOLOR Lemma Bank is envisaged as an ever-growing collection of canonical forms functioning as a central hub in the incipient knowledge base for Old Irish.
            </p>
        </Col>
    );
}

export default MainPage;

